<div class="row">
    <div class="col-md-6">
      <mat-form-field [attr.appearance]="aparienciaBuscador" [appearance]="aparienciaBuscador">
        <input matInput (keyup)="applyFilterDevelopers($event.target.value)" placeholder="Buscar recurso" aria-label="Buscar recurso" oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)" required [required]="buscadorRequerido" [attr.required]="atributoRequerido">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <button mat-raised-button class="btn btn-link btn-tumblr" (click)="addAllResourcesDevelopers()">
        <i class="fa fa-plus-circle"></i> Agregar A Todos
      </button>
    </div>
    <div class="col-md-3">
      <button mat-raised-button class="btn btn-link btn-tumblr" (click)="removeAllResourcesDevelopers()">
        <i class="fa fa-minus-circle"></i> Limpiar Asignaci&oacute;n
      </button>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-md-12 ">
      <div class="panel-dragdrop-container">
        <div class="panel-dragdrop-header">
          <div class="panel-dragdrop-title">
            <span><strong>Recursos Disponibles</strong></span>
          </div>
        </div>
        <div #scrollElementContentDevelopers cdk-scrollable style="height:240px; overflow-y:scroll">
          <div cdkDropList #todoDevelopersList="cdkDropList" [cdkDropListData]="resourcesFilterDevelopers"
            [cdkDropListConnectedTo]="[doneDevelopersList]" class="panel-dragdrop-list"
            (cdkDropListDropped)="dropDevelopers($event)">
            <div class="panel-dragdrop-box" *ngFor="let item of resourcesFilterDevelopers" cdkDrag>
               {{item.persona.nombreCompleto}} <i class="material-icons" [ngStyle]="{'color':'#757575'}">
                        person
                        </i></div>
          </div>
        </div>
      </div>

      <div class="panel-dragdrop-container">
        <div class="panel-dragdrop-header">
          <div class="panel-dragdrop-title">
            <span><strong>Recursos Asignados</strong></span> </div>
        </div>
        <div #scrollEl cdk-scrollable style="height:240px; overflow-y:scroll">
          <div cdkDropList #doneDevelopersList="cdkDropList" [cdkDropListData]="doneDevelopers"
            [cdkDropListConnectedTo]="[todoDevelopersList]" class="panel-dragdrop-list"
            (cdkDropListDropped)="dropDevelopers($event)">
            <div class="panel-dragdrop-box" *ngFor="let item of doneDevelopers" cdkDrag>
                {{item.persona.nombreCompleto}} <i class="material-icons" [ngStyle]="{'color':'#757575'}">
                    person
                    </i>
                  </div> 
          </div>
        </div>
      </div>
    </div>
  </div>